var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"d-flex-left"},[_c('erp-tree-status',{on:{"node-click":_vm.nodeClick}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex-right"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('keep-alive',[_c(_vm.componentId,{tag:"component"})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87b2cd30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/User/CustomerManagement/FurnishMaster.vue
// module id = null
// module chunks = 